<span>?</span>
@if (shouldShowIconChat$ | async) {
  <div
    (animate.enter)="showChatIcon($event)" animate.leave="chat-icon-leave"
    (click)="showSupport.emit('chat')"

    class="chat"
    >
    <div

      #chatBadgeIcon
      [matBadgeHidden]="(chatBadge | async) === 0 || isChatContainerOpen"
      [matBadge]="chatBadge | async"
      >
      <mat-icon>chat_bubble</mat-icon>
    </div>
  </div>
}
@if (shouldShowVisualGuidesList$ | async) {
  <div
    #visualGuidesIcon
    (click)="showGuides()"
    [class.guides-open]="visualGuidesState === 'open'" animate.enter="guides-enter" animate.leave="guides-leave"
    [matBadgeHidden]="visualGuidesCount === 0"
    [matBadge]="visualGuidesCount"
    class="faq"
    id="ZalamoVisualGuidesShortcutIcon"
    >
    <div>
      <mat-icon>smart_display</mat-icon>
    </div>
  </div>
}
